"use client";

import { useParams } from "next/navigation";
import { SearchCommand } from "@/components/shared/search-command";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { getIdFromSlug } from "@/lib/utils";
import { useI18n } from "@/locales/client";

interface MobileSearchDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const MobileSearchDrawer = ({
  open,
  onOpenChange,
}: MobileSearchDrawerProps) => {
  const t = useI18n();
  const params = useParams<{ studySetId: string }>();

  const studySetId = params.studySetId
    ? (getIdFromSlug(params.studySetId) ?? undefined)
    : undefined;

  const context = studySetId ? "study-set" : "global";

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="h-[85vh]">
        <DrawerHeader className="sr-only">
          <DrawerTitle>{t("searchCommand.placeholder.default")}</DrawerTitle>
          <DrawerDescription>
            {t("searchCommand.placeholder.default")}
          </DrawerDescription>
        </DrawerHeader>
        <div className="flex flex-1 flex-col overflow-hidden p-4 pt-2">
          <SearchCommand
            context={context}
            studySetId={studySetId}
            inline
            autoFocus
            onSelect={() => onOpenChange(false)}
          />
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default MobileSearchDrawer;
